import { render, staticRenderFns } from "./waModal.vue?vue&type=template&id=09c6a42c"
import script from "./waModal.vue?vue&type=script&lang=js"
export * from "./waModal.vue?vue&type=script&lang=js"
import style0 from "./waModal.vue?vue&type=style&index=0&id=09c6a42c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports